module.exports = __webpack_public_path__ + "img/balance.1395524d.png";